import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React, {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notification_getMyCourseAnnouncements_Api} from '../../../apis'
import usePaginationHelper from '../../AppLocals/hooks/usePaginationHelper'
import WorkspaceOrganizationAnnouncements from '../Insights/WorkspaceOrganizationAnnouncements'
import {CourseClassAnnouncementItem} from '../../AppLocals/Course/CourseClass/components/CourseClassAnnouncementItem'
import {BsBellFill, BsMegaphoneFill} from 'react-icons/bs'

const TabKeys = Object.freeze({
    ORGANIZATION: 'org',
    COURSE: 'course',
})

const WorkspaceCourseAnnouncements = () => {
    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        isToggleDefault: true,
        AdvancedFilter: NullAsDefault,
        renderFilter: NullAsDefault,
        pagerInfo: {
            RenderEntity: React.Fragment,
            query: {},
            PaginationMeta: NullAsDefault,
            apiInfo: notification_getMyCourseAnnouncements_Api,
            renderItem: (item) => (
                <CourseClassAnnouncementItem
                    key={item.id}
                    item={item}
                />
            ),
            renderWrap: (child) => (
                <div className="mt-3 flex flex-col gap-4">
                    {child}
                </div>
            ),
        },
        filter_params: {},
        dependencies: [],
        renderHeader: () => null,
    })

    return (
        <div className="flex flex-col">
            {pager_widget}
            <div className="h-16"/>
        </div>
    )
}

const WorkspaceNotifications = () => {
    const t = useTranslate()
    const [activeTab, setActiveTab] = useState(TabKeys.ORGANIZATION)

    const tabs = [
        {key: TabKeys.ORGANIZATION, label: 'organization announcements', icon: <BsBellFill size={13}/>},
        {key: TabKeys.COURSE, label: 'course announcements', icon: <BsMegaphoneFill size={13}/>},
    ]

    return (
        <div className="flex flex-col gap-4">
            <div className="flex gap-3 flex-wrap">
                {tabs.map(({key, label, icon}) => (
                    <button
                        key={key}
                        onClick={() => setActiveTab(key)}
                        className={classNames(
                            'flex items-center gap-1.5 px-3 py-1.5 shadow rounded-lg text-xs font-medium transition-all duration-300',
                            activeTab === key
                                ? 'bg-secondary-500 text-white'
                                : 'background text-color-200 hover:bg-secondary-50 hover:text-secondary-500'
                        )}>
                        {icon}
                        {t(label)}
                    </button>
                ))}
            </div>
            {activeTab === TabKeys.ORGANIZATION
                ? <WorkspaceOrganizationAnnouncements/>
                : <WorkspaceCourseAnnouncements/>
            }
        </div>
    )
}

export default WorkspaceNotifications
